export * from './lib/ng-media-manager.module';
export * from './lib/components/edit-media-dialog/edit-media-dialog.component';
export * from './lib/components/patient-file-selection-dialog/patient-file-selection-dialog.component';
